<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/>
        Categories
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'CategoryCreate'}">
          <button class="btn btn-success">Create New Category</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="categories" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'CategoryEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm"/>
              </span>
            </router-link>
            <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm"/>
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Categories",
  data() {
    return {
      categories: [],
      columns: ["id", "name", "weight", "topics", "parent", 'language', "created_at", "action"],
      options: {
        pagination: {nav: "fixed"},
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.$axios
          .get(`${ADMIN_URL}/categories`)
          .then((response) => {
            this.categories = response.data.category_list;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    handleDelete(id) {
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if (result.value) {
          this.deleteCategory(id);
        }
      }).catch(() => {
        // console.log('Sweetalert ERROR', );
      });
    },
    deleteCategory(id) {
      this.$axios
          .delete(`${ADMIN_URL}/categories/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getCategories()
          })
          .catch((error) => {
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>
